import React from "react";
import {ButtonProps} from "../types";
import {
  IconWrapper,
  AnimationWrapper,
  TextWrapper,
  SvgIcon,
} from "./shared-animation-styles";

const FailureAnimation = ({
  failureMessage,
}: Pick<ButtonProps, "failureMessage">): JSX.Element => {
  return (
    <AnimationWrapper
      aria-busy="false"
      aria-label={failureMessage}
      aria-live="polite"
      role="alert"
    >
      <IconWrapper>
        <SvgIcon
          height="20"
          viewBox="0 0 30 30"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm0 2C7.82 2 2 7.82 2 15s5.82 13 13 13 13-5.82 13-13S22.18 2 15 2zm6.713 5.636l1.446 1.446-6.508 6.509 6.508 6.509-1.446 1.446-6.508-6.509-6.51 6.509L7.25 22.1l6.509-6.509-6.51-6.509 1.447-1.446 6.509 6.509 6.508-6.509z" />
        </SvgIcon>
      </IconWrapper>
      <TextWrapper>{failureMessage}</TextWrapper>
    </AnimationWrapper>
  );
};

export default FailureAnimation;
